<script>
  import config from '../../libs/config.js';
  import func from '../../libs/functions.js';

  import _system from '../../libs/system';
	import { mapGetters, mapActions } from 'vuex'
  
  import api from '../../api/public'
  import apiPrivate from '../../api'

  import validate from 'validate.js'

  import AOS from 'aos'
  import 'aos/dist/aos.css'

	export default 
	{
    name: 'reset',
    data(){
      return {
        func: func,
        config: config,
        loading: false,
        mobile: false,
        change: false,
        signUp: {
          name: '',
          email: '',
          password: '',
          password2: ''
        },
        error: {
          password: false,
          email: {
            invalid: false,
            exist: false,
          },
          name: false
        }
      }
    },
    computed:{
      ...mapGetters('session', ['isLoggedIn', 'getJwt', 'getUser']),
      ...mapGetters('tags', ['tags', 'tagsByName'])
    },
      methods: 
      {
        ...mapActions('session', ['login','setIsLoggedIn']),
        ...mapActions('tags', ['setTags']),
        change(){

          if(validate.single(this.signUp.email, {presence: true, email: true})){
            console.log(validate.single(this.signUp.email, {presence: true, email: true}))
            return alert(validate.single(this.signUp.email, {presence: true, email: true})[0])
          }

          if(validate.single(this.signUp.password, { presence: true, length: {minimum: 6,message: "must be at least 6 characters" }})){
            console.log(validate.single(this.signUp.password, { presence: true, length: {minimum: 6,message: "Password must be at least 6 characters" }}))
            return alert(validate.single(this.signUp.password, { presence: true, length: {minimum: 6,message: "Password must be at least 6 characters" }})[0])
          }

          if(this.signUp.password != this.signUp.password2){
            return this.error.password = true;
          }

          if(!this.signUp.name.length || !this.signUp.email.length || !this.signUp.password.length || !this.signUp.password2.length){
            return alert('Inputs cannot be empty')
          }

          this.loading = true;

          let payload = { "email": this.signUp.email.toLowerCase().trim(), "password": this.signUp.password.trim(), "name": this.signUp.name }
          
          // User Sign Up
          api.post("/api/v1/users", payload, (err, data) => {

              if(err) {
                this.loading = false
                if(err.status == 409) return this.error.email.exist = true;
                if(err.status == 422) return this.error.email.invalid = true;
            }
              data.user.setup = true

              this.login({
                jwt: data.accessToken,
                user: data.user
              });
              this.setIsLoggedIn();

          //Create a workspace for new user
          _system.services.tags.getWithoutWorkspaceId((err, tags) => {
            this.setTags(tags);
              let payload = { "name":"Your Workspace", tags: [this.tagsByName['Individual']._id] }
              _system.services.workspaces.create(payload, (err, workspace) => {
                if (err) return console.log(err);
                  let payload = {
                    workspace: workspace._id,
                    user:  this.getUser._id,
                    tags :  [this.tagsByName['Admin']._id]
                  }
                  _system.services.workspaceusers.add(payload, (err, data) => {
                    if (err) return console.log(err);
                      this.loading = false;

                      this.$router.push({ name: "introduction" });

                      //segment
                      window.analytics.identify(this.getUser._id, {
                        id: this.getUser._id,
                        name: this.getUser.name,
                        email: this.getUser.email
                      });

                      window.analytics.alias(this.getUser._id);

                      window.analytics.track('Signed Up');



                  });
              })
            })

            

          });
		    }
    }, 
    created(){
      if(this.$route.query.email) {
        console.log(this.$route.query.email)
        this.change = false;
      }
      AOS.init();
                 if( navigator.userAgent.match(/Android/i) || navigator.userAgent.match(/webOS/i) || navigator.userAgent.match(/iPhone/i) || navigator.userAgent.match(/iPad/i) || navigator.userAgent.match(/iPod/i) || navigator.userAgent.match(/BlackBerry/i) || navigator.userAgent.match(/Windows Phone/i) ) this.mobile = true;
    }
	}
</script>

<template>
		<div :class="(mobile) ? 'ui grid stackable padded' : 'ui grid stackable middle aligned padded' ">
            <div  class="seven wide column centered">
              <div data-aos="zoom-in" class="ui basic segment">
                <img class="ui image centered" style="width: 170px;" src="/img/logo_white7.png" alt="">
              </div>
    
                      <div class="ui basic segment">

                      <div  v-if="change" style="padding:0;" class="ui basic segment">


                          <a :href="config.url + '/facebook/auth'" style="text-align: left;font-weight: 400; margin-bottom: 10px;" class="ui facebook large button fluid">
                          <i class="facebook icon"></i>
                          Sign Up with Facebook <span style="color: #97b6e4; margin-left: 4px;font-style: italic; font-size: 12px; font-weight: 400;">  Page's Comments, Direct Messages</span>
                          </a>
                        

                        <p @click="change = false" style="text-align: center;"> <span class="goEmail">Or continue with email  </span> </p>

                      </div>
                        <div v-if="!change" class="ui form">
                          <div v-if="mobile" class="field">
                            <div class="ui visible success message">
                              <p>🤩📱 Good News for yaa! Our mobile apps will be available soon for IOS and Android. </p>
                            </div>
                          </div>
                          <div class="field">
                              <label>Name</label>
                              <input v-model="signUp.name" placeholder="John Doe" type="text" :disabled="loading">
                          </div>
                          <div class="field">
                              <label>Email</label>
                              <input v-model="signUp.email" @input="signUp.email=$event.target.value.toLowerCase().trim()" placeholder="john@doordash.com" type="text" :disabled="loading">
                          </div>
                          <div v-show="error.email.exist" class="ui negative mini message ">
                            <p>This email is already in use. <a href="#">Forgot your password?</a> </p>
                          </div>
                          <div class="field">
                              <label>Password</label>
                              <input v-model="signUp.password" @input="signUp.password=$event.target.value.trim()" placeholder="Password" type="password" autocomplete="off" :disabled="loading">
                          </div>
                          <div v-if="signUp.password.length" class="field">
                              <label>Re-Type Your Password</label>
                              <input v-model="signUp.password2" @input="signUp.password2=$event.target.value.trim()" placeholder="Re-Type Your Password" type="password" autocomplete="off" v-on:keyup.enter="change()" :disabled="loading">
                          </div>
                          <div v-show="error.password" class="ui negative mini message ">
                            <p>Passwords are not equal!</p>
                          </div>
                          <div class="field">
                            <button @click="change()" v-bind:class="{ loading: loading }" :disabled="loading" class="ui orange button fluid">Change Password</button>
                          </div>
                        </div>    
                      </div>                      
                </div>
</div>
</template>


<style scoped>
.footer a {
  color: #999;
  border-bottom: 1px dotted #888888;
}

.goEmail {
  border-bottom: 1px solid #dddddd;
  color: #999999;
}

.goEmail:hover {
  border-bottom: 1px solid #aaaaaa;
  cursor:pointer;
}

</style>



// WEBPACK FOOTER //
// src/components/auth/Reset.vue